import { GenIcon } from '../helpers/IconBase.es.js';

const SaleColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "line",
        attr: {
          x1: "2.5",
          y1: "5.5",
          x2: "21.5",
          y2: "5.5",
          stroke: "#B3B3B3",
          strokeLinecap: "round"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "18.5",
          y1: "5.5",
          x2: "18.5",
          y2: "8.5",
          stroke: "#B3B3B3",
          strokeLinecap: "round"
        }
      },
      {
        tag: "line",
        attr: {
          x1: "5.5",
          y1: "5.5",
          x2: "5.5",
          y2: "8.5",
          stroke: "#B3B3B3",
          strokeLinecap: "round"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 8C2.44772 8 2 8.44771 2 9V19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19V9C22 8.44772 21.5523 8 21 8H3ZM6.59508 16C5.65228 16 5.02467 15.5603 5 14.8311H5.7811C5.83317 15.1555 6.16753 15.3485 6.61701 15.3485C7.05826 15.3485 7.35974 15.1394 7.35974 14.8552C7.35974 14.6005 7.17337 14.4558 6.6773 14.3566L6.26072 14.2761C5.4714 14.1233 5.08496 13.7534 5.08496 13.1769C5.08496 12.4692 5.71532 12 6.59508 12C7.5187 12 8.09972 12.4718 8.11343 13.1823H7.33233C7.30492 12.8525 7.01167 12.6542 6.59508 12.6542C6.18672 12.6542 5.91265 12.8418 5.91265 13.126C5.91265 13.3646 6.1045 13.5121 6.57042 13.6032L6.98974 13.6863C7.82565 13.8499 8.19016 14.1796 8.19016 14.7668C8.19016 15.5228 7.58447 16 6.59508 16ZM12.3653 15.9357H11.4856L11.1841 14.9973H9.79457L9.49309 15.9357H8.64348L10.0166 12.067H10.9895L12.3653 15.9357ZM10.4989 12.807H10.4797L9.97271 14.3914H11.006L10.4989 12.807ZM15.6087 15.2654H13.8793V12.067H13.0516V15.9357H15.6087V15.2654ZM17.2076 15.2654H19V15.9357H16.3799V12.067H19V12.7346H17.2076V13.6676H18.8986V14.2895H17.2076V15.2654Z",
          fill: "#EE112E"
        }
      }
    ]
  })(props);
};

export { SaleColored };
